// Author Liang Gang Qiang
// Date 2025-05-28 13:41:45

class SithMesPrdToolsInfo {
    constructor({
                    id = null,
                    departmentId = '',
                    departmentName = '',
                    type = '',
                    code = '',
                    name = '',
                    size = '',
                    pitchRow = '',
                    description = '',
                    specialDescription = '',
                    area = '',
                    bin = '',
                    workstationId = '',
                    workstationName = '',
                    quantity = '',
                    originStock = '',
                    availableStock = '',
                    date = '',
                    machineType = '',
                    remark = ''
                }
                = {}) {
        this.id = id;
        this.departmentId = departmentId;
        this.departmentName = departmentName;
        this.type = type;
        this.code = code;
        this.name = name;
        this.size = size;
        this.pitchRow = pitchRow;
        this.description = description;
        this.specialDescription = specialDescription;
        this.area = area;
        this.bin = bin;
        this.workstationId = workstationId;
        this.workstationName = workstationName;
        this.quantity = quantity;
        this.originStock = originStock;
        this.availableStock = availableStock;
        this.date = date;
        this.machineType = machineType;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesPrdToolsInfo();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'departmentName',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.departmentName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'type',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.type',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'code',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'epcCode',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'name',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'size',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.size',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pitchRow',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.pitchRow',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'description',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.description',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialDescription',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.specialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'area',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.area',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bin',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.bin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workstationName',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.workstationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'originStock',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.originStock',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'availableStock',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.availableStock',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'date',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.date',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machineType',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.machineType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'hasConflict',
            label: 'label.sith.prd.sithMesPrdToolsInfo.grid.hasConflict',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '冲突'},
                    {value: '2', text: '正常'}
                ]
            }
        }
    ])
}

const scrapVoConfigs = [
    {
        key: 'departmentName',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.departmentName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'type',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.type',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.name',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'size',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.size',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pitchRow',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.pitchRow',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdToolsInfo.grid.description',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    departmentIdFilter: '',
    departmentNameFilter: '',
    typeFilter: '',
    codeFilter: '',
    nameFilter: '',
    sizeFilter: '',
    pitchRowFilter: '',
    descriptionFilter: '',
    specialDescriptionFilter: '',
    areaFilter: '',
    binFilter: '',
    workstationIdFilter: '',
    workstationNameFilter: '',
    quantityFilter: '',
    originStockFilter: '',
    availableStockFilter: '',
    dateRteFilter: '',
    dateLteFilter: '',
    machineTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'departmentNameFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.departmentName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"departmentId":"id"}'
        }
    },
    {
        key: 'typeFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.type',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'codeFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sizeFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.size',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pitchRowFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.pitchRow',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.description',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.specialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'areaFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.area',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'binFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.bin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workstationIdFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.workstationId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workstationNameFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.workstationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"workstationId":"id"}'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'originStockFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.originStock',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableStockFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.availableStock',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dateRteFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.dateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dateLteFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.dateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineTypeFilter',
        label: 'label.sith.prd.sithMesPrdToolsInfo.filter.machineType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'departmentName',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.departmentName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"departmentId":"id"}'
        }
    },
    {
        key: 'type',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'size',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.size',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pitchRow',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.pitchRow',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.description',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialDescription',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.specialDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'area',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.area',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bin',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.bin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'workstationName',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.workstationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"workstationId":"id"}'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'originStock',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.originStock',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableStock',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.availableStock',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'date',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.date',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'machineType',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsInfo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdToolsInfo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs

    , scrapVoConfigs
}
